import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const NavPreviewCard = ({ tab, isActive }) => {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate(tab?.path)}
      className={`bg-card border rounded-2xl p-4 cursor-pointer active:scale-[0.98] transition-all duration-200 ${
        isActive ? 'border-accent/40 shadow-md shadow-accent/10' : 'border-border'
      }`}
    >
      <div className="flex items-start gap-3">
        <div className={`w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0 ${
          isActive ? 'bg-accent/15' : 'bg-muted'
        }`}>
          <Icon
            name={tab?.icon}
            size={22}
            className={isActive ? 'text-accent' : 'text-muted-foreground'}
          />
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 mb-0.5">
            <h3 className="text-sm font-semibold text-foreground truncate">{tab?.label}</h3>
            {isActive && (
              <span className="text-[10px] font-semibold text-accent bg-accent/10 px-1.5 py-0.5 rounded-full">Active</span>
            )}
          </div>
          <p className="text-xs text-muted-foreground leading-relaxed">{tab?.description}</p>
        </div>
        <Icon name="ChevronRight" size={16} className="text-muted-foreground flex-shrink-0 mt-0.5" />
      </div>
    </div>
  );
};

export default NavPreviewCard;
